import styled from "styled-components";
import device from 'utils/device'
import { Atom } from 'AppReact';

const template = styled.div`
  font-style: normal;
  font-weight: 600;
  font-size: 14px;

  @media ${device.tablet} {
    font-weight: 400;
    font-size: 24px;
  }
`;

export default Atom({ type: 'label', dataType: 'string', template })
